export default [
  {
    id: 'e54cedfe-82d1-4cf2-a319-a83b31718043',
    created_at: '2018-08-08T00:00:00.000+01:00',
    start: '2018-11-27T00:00:00.000+01:00',
    type: 'ecg.NSR',
    end: null,
    values: null,
  }, {
    id: 'fb8174a1-7eed-4d18-ad12-4c5c420d2982',
    created_at: '2018-08-08T00:00:00.000+01:00',
    start: '2018-11-27T00:00:00.000+01:00',
    type: 'hr',
    end: null,
    values: { hr: '96' },
  }, {
    id: '61802f06-deac-4e13-8c4b-297320845174',
    created_at: '2018-08-08T00:00:00.000+01:00',
    start: '2018-11-27T00:00:00.000+01:00',
    type: 'steps',
    end: '2018-11-28T01:00:00.000+01:00',
    values: { steps: '323' },
  }, {
    id: '61802f06-deac-4e13-8c4b-297320845174',
    created_at: '2018-08-08T00:00:00.000+01:00',
    start: '2018-11-27T00:00:00.000+01:00',
    type: 'glucose',
    end: null,
    values: { glucose: '99.009900990099' },
  }, {
    id: '61802f06-deac-4e13-8c4b-297320845174',
    created_at: '2018-08-08T00:00:00.000+01:00',
    start: '2018-11-27T00:00:00.000+01:00',
    type: 'pressure',
    end: null,
    values: {
      systolic: '117',
      diastolic: '54'
    },
  }, {
    id: '61802f06-deac-4e13-8c4b-297320845174',
    created_at: '2018-08-08T00:00:00.000+01:00',
    start: '2018-11-27T00:00:00.000+01:00',
    type: 'weight',
    end: null,
    values: { weight: '99.009900990099' },
  },
  {
    id: 'ec35814f164042bd80b0e5cbad1c6244',
    created_at: '2018-11-29T11:44:43.541Z',
    created_at_ts: 1543491883541,
    type: 'sleep',
    start: '2018-11-27T20:12:00.000Z',
    start_ts: 1543349520000,
    end: '2018-11-27T22:55:00.000Z',
    end_ts: 1543359300000,
    source: 'CUSTOMER',
    event_id: null,
    latitude: null,
    longitude: null,
    values: { stage: 'Unknown' },
  },
  {
    id: '18d432b302174361890f490847bf999d',
    created_at: '2018-11-29T10:35:58.873Z',
    created_at_ts: 1543487758873,
    type: 'floors',
    start: '2018-11-27T16:00:00.000Z',
    start_ts: 1543334400000,
    end: '2018-11-27T17:00:00.000Z',
    end_ts: 1543338000000,
    source: 'CUSTOMER',
    event_id: null,
    latitude: null,
    longitude: null,
    values: { floors: 4 },
  },
  {
    id: 'df69927a1eb04a58b8f4ad0024eaac03',
    created_at: '2018-11-29T10:35:58.873Z',
    created_at_ts: 1543487758873,
    type: 'floors',
    start: '2018-11-27T15:00:00.000Z',
    start_ts: 1543330800000,
    end: '2018-11-27T16:00:00.000Z',
    end_ts: 1543334400000,
    source: 'CUSTOMER',
    event_id: null,
    latitude: null,
    longitude: null,
    values: { floors: 1 },
  },
  {
    id: '55830e032cdb4b939199ce16b88d0dc3',
    created_at: '2018-11-29T15:20:36.635Z',
    created_at_ts: 1543504836635,
    type: 'recreational_product',
    start: '2018-11-27T00:00:00.000Z',
    start_ts: 1543276800000,
    end: null,
    end_ts: null,
    source: 'CUSTOMER',
    event_id: null,
    latitude: null,
    longitude: null,
    values: {
      amount: 'test',
      count: '',
      name: 'test',
      product: 'Nicotine',
    },
  },
];